module.exports = __webpack_public_path__ + "img/backyard-canopy.422a2c0b.webp";